import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import DiscountTable from "../../elements/Tables/DiscountTable/DiscountTable";
import DiscountCreationForm from "../../elements/Forms/DiscountCreationForm/DiscountCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_DISCOUNT_API,
} from "../../../Constants/Apis"
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteDiscount } from "../../../Services/DiscountService";

const { Search } = Input;

const DiscountPage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [discountId, setDiscountId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setDiscountId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deleteDiscount(discountId);
      message.success("Discount deleted successfully");
      callReFetch();
    } catch (error) {
      console.error("Error deleting discount:", error);
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete discount."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_DISCOUNT_API}`, state);


  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New Discount
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <DiscountTable
        history={history}
        loading={loading}
        data={data}
        callReFetch={callReFetch}
        userData={userData}
        dispatch={dispatch}
        handleDelete={handleDelete}
      />

      <Modal
        title="Create Discount"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <DiscountCreationForm
          history={history}
          userData={userData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
        />
      </Modal>

      <Modal
        title="Delete Discount"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this discount?</p>
      </Modal>
    </div>
  );
};

DiscountPage.propTypes = {};

export default DiscountPage;
